import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderInspectionDataSchema } from './ServicesProviderInspectionData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderInspection extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderInspectionDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderInspection.validation', `ServicesProviderInspection data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.INSPECTION,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.INSPECTION, ServicesProviderInspection);

export { ServicesProviderInspection };
//# sourceMappingURL=ServicesProviderInspection.js.map
